/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permissions_TitleInputs */

const en_agent_authorization_permissions_title = /** @type {(inputs: Agent_Authorization_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project permissions`)
};

const zh_agent_authorization_permissions_title = /** @type {(inputs: Agent_Authorization_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目权限`)
};

/**
* | output |
* | --- |
* | "Project permissions" |
*
* @param {Agent_Authorization_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permissions_title = /** @type {((inputs?: Agent_Authorization_Permissions_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permissions_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permissions_title(inputs)
	return zh_agent_authorization_permissions_title(inputs)
});
export { agent_authorization_permissions_title as "agent.authorization.permissions_title" }